module.exports = __webpack_public_path__ + "img/newspaper-selected.84c7fdc8.png";